// @flow

import type { DepositState, DepositActions, ApiState } from '../types';
import {
  WS_INIT_DEPOSIT,
  WS_INIT_DEPOSIT_SUCCESS,
  WS_CHECK_DEPOSIT_REQUEST,
  WS_CHECK_DEPOSIT_SUCCESS,
  WS_CHECK_DEPOSIT_ERROR,
  WS_LIST_AVAILABLE_DEPOSIT_METHODS_REQUEST,
  WS_LIST_AVAILABLE_DEPOSIT_METHODS_SUCCESS,
  WS_LIST_AVAILABLE_DEPOSIT_METHODS_ERROR,
  WS_SCAN_CREDIT_CARD_REQUEST,
  WS_SCAN_CREDIT_CARD_SUCCESS,
  WS_SCAN_CREDIT_CARD_ERROR,
  WS_START_DEPOSIT_REQUEST,
  WS_START_DEPOSIT_SUCCESS,
  WS_START_DEPOSIT_ERROR,
  WS_CLEAR_DEPOSIT_RESPONSES,
  WS_DISCONNECTED_DEPOSIT,
} from '../actions';

const requestInitialState = (): ApiState<any, any, any> => ({
  loading: false,
  time: null,
  success: false,
  params: null,
  error: null,
  response: null,
});

export const initialState: DepositState = {
  initializing: false,
  initialized: false,
  depositId: null,
  depositActionContent: null,
  depositMethods: [],
  checkDeposit: requestInitialState(),
  listAvailableDepositMethods: requestInitialState(),
  scanCreditCard: requestInitialState(),
  startDeposit: requestInitialState(),
};

export const depositReducer = (
  state: DepositState = initialState,
  action: DepositActions
): DepositState => {
  switch (action.type) {
    case WS_INIT_DEPOSIT:
      return {
        ...state,
        initializing: true,
        initialized: false,
      };

    case WS_INIT_DEPOSIT_SUCCESS:
      return {
        ...state,
        initializing: false,
        initialized: true,
      };

    case WS_DISCONNECTED_DEPOSIT:
      return {
        ...state,
        initializing: false,
        initialized: false,
      };

    case WS_CHECK_DEPOSIT_REQUEST:
      return {
        ...state,
        // If check deposit, unstore depositId and action content
        depositId: null,
        depositActionContent: null,
        checkDeposit: {
          loading: true,
          time: Date.now(),
          success: false,
          params: action.payload,
          error: null,
          response: null,
        },
      };

    case WS_CHECK_DEPOSIT_SUCCESS:
      return {
        ...state,
        checkDeposit: {
          ...state.checkDeposit,
          loading: false,
          time: null,
          success: true,
          error: null,
          response: action.payload,
        },
      };

    case WS_CHECK_DEPOSIT_ERROR:
      return {
        ...state,
        checkDeposit: {
          ...state.checkDeposit,
          loading: false,
          time: null,
          success: false,
          error: action.payload,
          response: null,
        },
      };

    case WS_LIST_AVAILABLE_DEPOSIT_METHODS_REQUEST:
      return {
        ...state,
        listAvailableDepositMethods: {
          loading: true,
          time: Date.now(),
          success: false,
          params: action.payload,
          error: null,
          response: null,
        },
      };

    case WS_LIST_AVAILABLE_DEPOSIT_METHODS_SUCCESS:
      return {
        ...state,
        depositMethods: action.payload.methods,
        listAvailableDepositMethods: {
          ...state.listAvailableDepositMethods,
          loading: false,
          time: null,
          success: true,
          error: null,
          response: action.payload,
        },
      };

    case WS_LIST_AVAILABLE_DEPOSIT_METHODS_ERROR:
      return {
        ...state,
        listAvailableDepositMethods: {
          ...state.listAvailableDepositMethods,
          loading: false,
          time: null,
          success: false,
          error: action.payload,
          response: null,
        },
      };

    case WS_SCAN_CREDIT_CARD_REQUEST:
      return {
        ...state,
        scanCreditCard: {
          loading: true,
          time: Date.now(),
          success: false,
          params: action.payload,
          error: null,
          response: null,
        },
      };

    case WS_SCAN_CREDIT_CARD_SUCCESS:
      return {
        ...state,
        scanCreditCard: {
          ...state.scanCreditCard,
          loading: false,
          time: null,
          success: true,
          error: null,
          response: action.payload,
        },
      };

    case WS_SCAN_CREDIT_CARD_ERROR:
      return {
        ...state,
        scanCreditCard: {
          ...state.scanCreditCard,
          loading: false,
          time: null,
          success: false,
          error: action.payload,
          response: null,
        },
      };

    case WS_START_DEPOSIT_REQUEST:
      return {
        ...state,
        startDeposit: {
          loading: true,
          time: Date.now(),
          success: false,
          params: action.payload,
          error: null,
          response: null,
        },
      };

    case WS_START_DEPOSIT_SUCCESS:
      return {
        ...state,
        // If start deposit, store depositId
        depositId: action.payload.deposit_id,
        depositActionContent:
          (action.payload.external_step &&
            action.payload.external_step.content) ||
          '',
        startDeposit: {
          ...state.startDeposit,
          loading: false,
          time: null,
          success: true,
          error: null,
          response: action.payload,
        },
      };

    case WS_START_DEPOSIT_ERROR:
      return {
        ...state,
        startDeposit: {
          ...state.startDeposit,
          loading: false,
          time: null,
          success: false,
          error: action.payload,
          response: null,
        },
      };

    case WS_CLEAR_DEPOSIT_RESPONSES:
      return {
        ...state,
        checkDeposit: requestInitialState(),
        listAvailableDepositMethods: requestInitialState(),
        scanCreditCard: requestInitialState(),
        startDeposit: requestInitialState(),
      };

    default:
      return state;
  }
};
